import { css } from 'styled-components';

export const fadeIn = css`
  visibility: visible;
  opacity: 1;
  transition:
    opacity 250ms ease-in,
    visibility 0ms ease-in 0ms;
`;

export const fadeOut = css`
  visibility: hidden;
  opacity: 0;
  transition:
    opacity 250ms ease-in,
    visibility 0ms ease-in 250ms;
`;
